/**
 * Whether Become-a-Member checkout should show skeletons instead of Stripe
 * Elements.
 *
 * After Elements have mounted once, keep them mounted through background
 * loading flickers so PaymentElement does not remount and wipe card input.
 *
 * @param options.hasMountedCheckout - Elements have successfully mounted once
 * @param options.isLoading - Plan / payment-methods / PayPal still loading
 * @returns True only for the initial loading gate
 */
export const shouldShowCheckoutSkeleton = (options: {
	hasMountedCheckout: boolean;
	isLoading: boolean;
}): boolean => {
	const { hasMountedCheckout, isLoading } = options;
	return isLoading && !hasMountedCheckout;
};
